import { Link } from "@trussworks/react-uswds";
import { Trans, useTranslation } from "react-i18next";
import styled from "styled-components";
import { AnalyticsAction, logEvent } from "../../utils/analytics";
const Highlight = styled.div`
   color: #1A103F;
  background-color: #F8D347;
  padding: 1px 20px 20px 20px;
  margin-top: 1.50em;
  margin-bottom: 0.93em;
  .nice_font;
`;


type ProviderUpdateInfoProps = {
  header: string;
};
function ProviderUpdateInfo({ header}: ProviderUpdateInfoProps) {
  const { t } = useTranslation();
  return (
    <Highlight >
      <h2 className="margin-top-3 body_font dark_blue" style={{"fontFamily":"Trebuchet MS"}}>{header}</h2>
      <Trans i18nKey="bhaProviderUpdate" className="body_font dark_blue">
          <span className="body_font dark_blue" style={{'color':'#1E6692'}}>We value your input</span>
          <Link 
           onClick={() => logEvent(AnalyticsAction.ProviderDetailUpdateInclusion)}
           href={t("complaintFormUrl")} 
           rel="noreferrer" 
           target="_blank" 
           variant="external"
           className="body_font dark_blue"
           >
            <span className="body_font" style={{color:'#1E6692'}}>Submit a form to report missing or incorrect information.</span>
          </Link>
        </Trans>
    </Highlight>
  );
}
export default ProviderUpdateInfo;
